export const AGE_MAX_VALUE = '100'
export const AGE_MIN_VALUE = '1'
